import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleTag", "size", "img", "tag", "time", "href", "disabled", "date", "target", "onClick", "data-test-id", "layoutType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { WatchSVG } from '@sbercloud/uikit-product-icons';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { Tag } from '@snack-uikit/tag';
import { TruncateString } from '@snack-uikit/truncate-string';
import { Typography } from '@snack-uikit/typography';
import { useCardInteractions } from '../../hooks';
import styles from "./styles.module.css";
import { getTypographySize } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CardMedia(_ref) {
  var title = _ref.title,
    _ref$titleTag = _ref.titleTag,
    titleTag = _ref$titleTag === void 0 ? 'h2' : _ref$titleTag,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size,
    img = _ref.img,
    tag = _ref.tag,
    time = _ref.time,
    href = _ref.href,
    disabled = _ref.disabled,
    date = _ref.date,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_self' : _ref$target,
    onClick = _ref.onClick,
    _ref$dataTestId = _ref['data-test-id'],
    dataTestId = _ref$dataTestId === void 0 ? 'card-media' : _ref$dataTestId,
    layoutType = _ref.layoutType,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useCardInteractions = useCardInteractions({
      href: href,
      disabled: disabled,
      onClick: onClick
    }),
    anchorRef = _useCardInteractions.anchorRef,
    handleLinkClick = _useCardInteractions.handleLinkClick,
    handleCardKeyDown = _useCardInteractions.handleCardKeyDown;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _jsxs("div", _objectSpread(_objectSpread({}, extractSupportProps(rest)), {}, {
      onKeyDown: handleCardKeyDown,
      "data-test-id": dataTestId,
      "data-size": size,
      className: styles.root,
      "data-disabled": disabled || undefined,
      "data-layout-type": layoutType
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      ,
      tabIndex: 0,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.imgWrapper,
        children: /*#__PURE__*/_jsx("img", {
          className: styles.img,
          src: img,
          alt: "card-media-img"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.header,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.left,
          children: [/*#__PURE__*/_jsx(Tag, _objectSpread({
            size: "xs"
          }, tag)), time && /*#__PURE__*/_jsxs("span", {
            className: styles.time,
            children: [/*#__PURE__*/_jsx(WatchSVG, {
              className: styles.icon,
              size: 16
            }), /*#__PURE__*/_jsx(Typography.SansBodyM, {
              className: styles.minutes,
              children: "".concat(time, " \u043C\u0438\u043D")
            })]
          })]
        }), size !== 's' && /*#__PURE__*/_jsx(Typography.SansBodyM, {
          className: styles.date,
          children: date
        })]
      }), /*#__PURE__*/_jsx(Typography, {
        tag: titleTag,
        family: "sans",
        purpose: "title",
        size: getTypographySize(layoutType, size),
        className: styles.title,
        "data-test-id": "".concat(dataTestId, "__title"),
        children: href ? /*#__PURE__*/_jsx("a", {
          tabIndex: -1,
          ref: anchorRef,
          href: href,
          target: target,
          onClick: handleLinkClick,
          "data-test-id": "".concat(dataTestId, "__title-link"),
          children: /*#__PURE__*/_jsx(TruncateString, {
            text: title,
            maxLines: 4
          })
        }) : title
      })]
    }))
  );
}